import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const isProduction = environment.production;

if (environment.grafanaFaroCollectorUrl) {
  initializeFaro({
    url: environment.grafanaFaroCollectorUrl,
    app: {
      name: 'Risk Action Gateway',
      version: '1.0.0',
      environment: isProduction ? 'production' : 'development',
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
  });
}

if (isProduction) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
